import { NgModule } from '@angular/core';

import { CoreCommonModule } from '@xbaht/ui/core/common.module';

import { HorizontalMenuModule } from './menu/horizontal-menu/horizontal-menu.module';
import { MenuComponent } from './menu/menu.component';
import { VerticalMenuModule } from './menu/vertical-menu/vertical-menu.module';

@NgModule({
  declarations: [MenuComponent],
  imports: [CoreCommonModule, VerticalMenuModule, HorizontalMenuModule],
  exports: [MenuComponent],
})
export class MenusModule {}
